import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RasporedLjudiService {

  constructor(private _http: HttpClient) { }

  dohvatiSveLinije(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDjelatnike(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_djelatnike_na_liniji', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveDjelatnike(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_djelatnike_za_liniju', a)
      .pipe(map((res: any) => res));
  }

  spremiDjelatnika(a: any) {
    return this._http.post(AppConfig.ipAddress + 'spremi_djelatnike_na_liniju', a)
      .pipe(map((res: any) => res));
  }

  urediDjelatnika(a: any) {
    return this._http.put(AppConfig.ipAddress + 'linija_djelatnik_uredi', a)
      .pipe(map((res: any) => res));
  }

  obrisiDjelatnika(a: any) {
    return this._http.post(AppConfig.ipAddress + 'brisanje_djelatnika_sa_linije', a)
      .pipe(map((res: any) => res));
  }

  tjedanUGodini(a: any) {
    return this._http.post(AppConfig.ipAddress + 'tjedan_u_godini', a)
      .pipe(map((res: any) => res));
  }

  provjeraDjelatnikaPoTjednu(a: any) {
    return this._http.post(AppConfig.ipAddress + 'provjera_tjedna_u_godini', a)
      .pipe(map((res: any) => res));
  }

  kreirajRaspored(a: any) {
    return this._http.post(AppConfig.ipAddress + 'kreiranje_rasporeda_za_nadolazeci_tjedan', a)
      .pipe(map((res: any) => res));
  }

  pravaKorisnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prijavaprava', a)
      .pipe(map((res: any) => res));
  }
}
